/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-11 14:30:32
 * @FilePath: /insuranceagent-ui/src/const/dic/dic.js
 * @Description:  结算相关字典
 */

//结算方式
export const dicSettleType = [
	{
		label: '服务对公',
		value: 'PUBLIC',
	},
	{
		label: '中介对公',
		value: 'INTER',
	},
	{
		label: '第三方清分',
		value: 'PRIVATE',
	},
	{
		label: '代理人佣金',
		value: 'AGENT',
	},
]

//计税类型
export const dicSettleTaxType = [
	{
		label: '乘数',
		value: 'MULTIPLY',
	},
	{
		label: '除数',
		value: 'DIVIDE',
	},
]

//结算打款账户
export const dicSettleRemitAccount = [
	{
		label: '美保科技',
		value: 'MB',
	},
	{
		label: '美保经纪',
		value: 'MBJJ',
	},
	{
		label: '蓝工科技',
		value: 'LG',
	},
]

//结算平台
export const dicSettlePlatform = [
	{
		label: '仲川',
		value: 'ZC',
	},
	{
		label: '宁波迅保',
		value: 'XB',
	},
]
